import Barcode from 'react-barcode';
import { templateMock } from './constant';

export default function PdfTemplate7({ data, userInfo }: any) {
  const renderData = data || templateMock;

  return (
    renderData &&
    renderData.map((item: any) => (
      <div className="templates p-4    font-sans [&>div]:text-[6pt] w-[9.5cm]   " style={{ pageBreakInside: 'avoid' }}>
        <div className="flex flex-col gap-y-2 mb-2">
          <p className=" text-[10pt] text-center font-bold "> اطلاعات فرستنده</p>

          <div className="  rounded-lg gap-x-6 justify-between  flex">
            <h2 className=" font-semibold ">
              {' '}
              فرستنده: <span className="font-normal ">{item.senderName}</span>
            </h2>
            <h2 className=" font-semibold">
              تلفن فرستنده: <span className="font-normal">{item.senderMobile}</span>
            </h2>
          </div>

          <div className="  rounded-lg ">
            <h2 className=" font-semibold ">
              {' '}
              آدرس فرستنده:{' '}
              <span className="font-normal">{[item.senderCityName, item.senderAddress].filter(Boolean).join(' ')}</span>
            </h2>
          </div>
        </div>
        <div className="border-t-2 border-gray-300 my-2"></div>
        {/* بخش اطلاعات گیرنده */}
        <div className="flex flex-col gap-y-2 mb-2">
          <p className="text-[10pt] text-center font-bold "> اطلاعات گیرنده</p>

          <div className="  rounded-lg gap-x-6  justify-between flex">
            <h2 className=" font-semibold ">
              {' '}
              گیرنده: <span className="font-normal">{item.receiverProspectName}</span>
            </h2>
            <h2 className=" font-semibold">
              تلفن گیرنده: <span className="font-normal">{item.receiverProspectMobile}</span>
            </h2>
          </div>

          <div className="  rounded-lg ">
            <h2 className="text-md font-semibold ">
              {' '}
              آدرس گیرنده:{' '}
              <span className="font-normal">
                {[item.receiverState?.text, item.receiverCityName, item.receiverAddress]
                  .filter(Boolean) // حذف مقادیر خالی/undefined/null
                  .join(' - ')}
              </span>
            </h2>
          </div>
        </div>

        {/* جدول هزینه‌ها */}
        <div className="border-t-2 border-gray-300 my-2"></div>
        <div className="mb-2">
          <p className="text-[10pt] font-bold  text-center"> هزینه ارسال (ریال)</p>

          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50">
                <th className="text-right p-1 border border-gray-300">پس کرایه</th>
                <th className="text-right p-1 border border-gray-300">
                  {item.paymentBy?.id ===0 ? '' : `  ${item.grossPrice?.toLocaleString()}`}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-right p-1 border border-gray-300">پرداخت هزینه کالا (COD)</td>
                <td className="text-right p-1 border border-gray-300">{item.costOfGoods?.toLocaleString() || ''}</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="text-right p-1 border border-gray-300">جمع پرداخت</td>
                <td className="text-right p-1 border border-gray-300">
                  {item.paymentBy?.id ===0  ? "":(item.grossPrice + item.costOfGoods)?.toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="border-t-2 border-gray-300 my-2"></div>
        <div>
          <p className="text-[10pt] font-bold mb-2 text-center"> توضیحات</p>
          <div
            className="
          rounded-lg"
          >
            <p className="text-gray-600">{item.messageForDriver}</p>
          </div>
        </div>

        <div className="flex flex-col items-center mt-4 p-4  rounded-lg ">
          <div className="flex items-center h-16 ">
            <Barcode width={2.3} height={60} value={item.cprNumber} displayValue={true} fontSize={10} />
          </div>
        </div>
        <style>{`
            @media print {
              @page {
                size: 9.5cm 12.5cm;
         
                   padding:2px;
     
              }   
            }
            `}</style>
      </div>
    ))
  );
}
